import ApplicationController from "./application_controller";
import Rails from "@rails/ujs";

/*
 * Usage
 * =====
 *
 * add data-controller="auto-submit" to your <form> element
 *
 * Action (add this to a <select> field):
 * data-action="change->auto-submit#submit"
 *
 */
export default class extends ApplicationController {
  submit() {
    try {
      Rails.fire(this.element, "submit");
    } catch (error) {
      // Ignore AbortError - form submission was cancelled
      if (error.name !== 'AbortError') {
        // Auto submit error
      }
    }
  }

  static targets = ["loadingIndicator"]

  showLoading() {
    if (this.hasLoadingIndicatorTarget) {
      this.loadingIndicatorTarget.classList.remove("hidden")
    }
  }

  hideLoading() {
    if (this.hasLoadingIndicatorTarget) {
      this.loadingIndicatorTarget.classList.add("hidden")
    }
  }
}
